import { Modifier, TimeSlotDefinition } from './schedule';
import {
    //slupninox,
    hapxi,
    //insomnia,
    Pill,
    /*sleep*/
    stomachache,
    tumbumrum,
    melancholy,
    antiau,
    headache,
    living,
    sickness,
    hypertension,
    chillma,
} from './status';

export type Day = {
    name: string,
    definitions: TimeSlotDefinition[]
}

export type Level = {
    key: string;
    availablePills: Array<Pill & { amount: number }>,
    days: Day[],
}

const nightytimes: TimeSlotDefinition[] = [
];

const foodytimes: TimeSlotDefinition[] = [
    {
        from: 0,
        modifiers: [ Modifier.isMealtime ],
        effects: [],
    }, {
        from: 2,
        modifiers: [ Modifier.isMealtime ],
        effects: [],
    },
    {
        from: 4,
        modifiers: [ Modifier.isMealtime ],
        effects: [],
    },
];

const withAmount = (pill: Pill, amount: number): Pill & { amount: number } =>
    ({ ...pill, amount });

const dayDefinitionLevel1 =
    [ ...foodytimes,
        {
            from: 0,
            effects: [ living ],
            modifiers: [ ],
        }, {
            from: 3,
            effects: [ sickness ],
            modifiers: [ ],
        },
    ];

export const level1: Level = {
    key: 'level1',
    availablePills: [ withAmount(hapxi, 3), withAmount(tumbumrum, 5) ],
    days: [
        {
            name: 'monday',
            definitions: dayDefinitionLevel1,
        },
        {
            name: 'tuesday',
            definitions: dayDefinitionLevel1,
        },
        {
            name: 'wednesday',
            definitions: dayDefinitionLevel1,
        },
        {
            name: 'thursday',
            definitions: dayDefinitionLevel1,
        },
        {
            name: 'friday',
            definitions: dayDefinitionLevel1,
        },
    ],
};

const dayDefinitionLevel2 =
    [ ...foodytimes,
        {
            from: 0,
            effects: [ living ],
            modifiers: [ ],
        }, {
            from: 0,
            effects: [ hypertension ],
            modifiers: [ ],
        },
    ];

export const level2: Level = {
    key: 'level2',
    availablePills: [ withAmount(hapxi, 3), withAmount(chillma, 5), withAmount(antiau, 5), withAmount(tumbumrum, 2) ],
    days: [
        {
            name: 'monday',
            definitions: dayDefinitionLevel2,
        },
        {
            name: 'tuesday',
            definitions: dayDefinitionLevel2,
        },
        {
            name: 'wednesday',
            definitions: dayDefinitionLevel2,
        },
        {
            name: 'thursday',
            definitions: dayDefinitionLevel2,
        },
        {
            name: 'friday',
            definitions: dayDefinitionLevel2,
        },
    ],
};
